import React, { useContext } from "react"
import { Outlet } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import MainNavbar from './MainNavbar';
import { Box, Link, Button } from '@material-ui/core';
import ArrowBackIosNewIcon from '@material-ui/icons/ArrowBackIosNew';

import LanguageContext from "../contexts/LanguageContext"
import MyModal from "./ui/MyModal"

import rectBlackCheckWhite from "../images/rectBlackCheckWhite.svg"

const MainLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'Questrial',
  })
);

const MainLayoutWrapper = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: 70,
  paddingBottom:60,
  position:'relative',
  zIndex:2,
});

const MainLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const MainLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'hidden',
});

const MainLayout = ( {children} ) => {

  const {
    actLanguage,
    actLanguageFlag,
    languageValues,
    modalChangeLanguage,
    setModalChangeLanguage,
    allLanguages,
    changeLanguage,
  } = useContext(LanguageContext)

  return (
    <MainLayoutRoot>
      <Box sx={{
        position: "fixed",
        width: "1028px",
        height: "537px",
        left: "calc(50% - 1028px/2)",
        top: "0px",
        backgroundImage: "url('./static/MainLayout-bg.svg')",
        zIndex:0,
      }} />
      <Box sx={{
        position: "fixed",
        width: "1100px",
        height: "600px",
        left: "calc(50% - 1100px/2)",
        top: "0px",
        background: "radial-gradient(72.67% 72.67% at 50% 8.92%, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
        zIndex:1,
      }} />
      <MainNavbar />
      <MainLayoutWrapper>
        <MainLayoutContainer>
          <MainLayoutContent>
            {children}
          </MainLayoutContent>
        </MainLayoutContainer>
      </MainLayoutWrapper>
      <Box sx={{
        position:"fixed",
        zIndex:2,
        bottom:"0px",
        height:["40px","60px"],
        display:"flex",
        flexDirection:"column",
        paddingLeft:"25px",
        paddingRight:"25px",
        paddingTop:[0,"10px"],
        fontSize:["13px","16px"],
        userSelect:"none",
        whiteSpace:"nowrap",
        width:["100%", "unset"],
      }}>
        <Box sx={{
          display:"flex",
          alignItems:"center",
          justifyContent:["center", "flex-start"],
          gap:"6px",
        }}>
          <Box
            sx={{
              width:["12px", "14px"],
              height:["12px", "14px"],
              cursor:"pointer",
              backgroundImage:`url(${actLanguageFlag})`,
              backgroundSize:"contain",
              backgroundRepeat:"no-repeat",
              backgroundPosition:"center center",
            }}
            onClick={() => {
              setModalChangeLanguage(true)
            }}
          />
          <Box
            sx={{
              display:"flex",
              alignItems:"center",
              gap:"4px",
              cursor:"pointer",
            }}
            onClick={() => {
              setModalChangeLanguage(true)
            }}
          >
            {languageValues?.language[actLanguage]}
            <ArrowBackIosNewIcon sx={{
              transform: "rotate(-90deg)",
              width:["12px", "14px"],
            }}/>
          </Box>
          <Box sx={{
            color : "#565656",
            marginLeft:"12px",
          }}>
            {languageValues?.mainLayout?.needHelp[actLanguage]}
            <Link
              component={RouterLink}
              sx={{marginLeft:"4px",}}
              onClick={() => {
                window.$crisp.push(['do', 'chat:open'])
                window.$crisp.push(['do', 'chat:show'])
              }}
            >
              {languageValues?.mainLayout?.itsHere[actLanguage]}
            </Link>
          </Box>
        </Box>
      </Box>

      <MyModal
        isOpen={modalChangeLanguage}
        maxWidth="xs"
        onClose={() => {
          setModalChangeLanguage(false)
        }}
        title={languageValues?.mainLayout?.languageTitle[actLanguage]}
        subTitle={languageValues?.mainLayout?.languageSubTitle[actLanguage]}
      >
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          flex:1,
          justifyContent:["space-between", "unset"],
          gap:"10px",
        }}>
          <Box sx={{
            display:"flex",
            flexDirection:"column",
            gap:"10px"
          }}>
            {allLanguages?.map((lang, index) => {
              let isSelected = actLanguage === lang?.id ? true : false
              return (
                <Box
                  key={index}
                  sx={{
                    border: isSelected ? "1px solid black" : "1px solid #EFEFEF",
                    backgroundColor: isSelected ? "background.grey" : "white",
                    padding:["15px", "20px"],
                    display:"flex",
                    alignItems:"center",
                    userSelect:"none",
                    cursor:"pointer",
                    justifyContent:"space-between",
                  }}
                  onClick={() => {
                    changeLanguage(lang?.id)
                  }}
                >
                  <Box sx={{
                    display:"flex",
                    alignItems:"center",
                  }}>
                    <Box
                      sx={{
                        width:["20px", "25px"],
                        height:["20px", "25px"],
                        cursor:"pointer",
                        backgroundImage:`url(${lang?.flag})`,
                        backgroundSize:"contain",
                        backgroundRepeat:"no-repeat",
                        backgroundPosition:"center center",
                      }}
                    />
                    <Box sx={{
                      paddingLeft:"15px",
                      color:"text.black",
                      fontSize:["16px", "20px"]
                    }}>
                      {languageValues?.language[lang?.id]}
                    </Box>
                  </Box>
                  {isSelected &&
                    <Box
                      sx={{
                        width:["21px", "26px"],
                        height:["21px", "26px"],
                        cursor:"pointer",
                        backgroundImage:`url(${rectBlackCheckWhite})`,
                        backgroundSize:"contain",
                        backgroundRepeat:"no-repeat",
                        backgroundPosition:"center center",
                      }}
                    />
                  }
                </Box>
              )
            })}
          </Box>
          <Box sx={{
            paddingTop:["0px", "30px"]
          }}>
            <Button
              color="primary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              onClick={() => {
                setModalChangeLanguage(false)
              }}
            >
              {languageValues?.mainLayout?.languageButtonContinue[actLanguage]}
            </Button>
          </Box>
        </Box>
      </MyModal>
    </MainLayoutRoot>
  )
}

export default MainLayout;
